import {
  FULL_CHART_HEIGHT,
  REDUCED_CHART_HEIGHT,
  LG_CHART_WIDTH,
  MD_CHART_WIDTH,
  SM_CHART_WIDTH,
  XS_CHART_WIDTH,
} from "./styles";

export const MAX_MD_VIEWPORT_QUERY = "(max-width: 1600px)";

export const BASE_BAR_CHART_PROPS = {
  yAxisLabel: "Operational Risk",
  xAxisLabel: "Field Name",
  yDomainPadding: 1.05,
};

export const LG_BAR_CHART_SIZE = {
  width: LG_CHART_WIDTH,
  height: FULL_CHART_HEIGHT,
};

export const MD_BAR_CHART_SIZE = {
  width: MD_CHART_WIDTH,
  height: REDUCED_CHART_HEIGHT,
};

export const SM_BAR_CHART_SIZE = {
  width: SM_CHART_WIDTH,
  height: FULL_CHART_HEIGHT,
};

export const XS_BAR_CHART_SIZE = {
  width: XS_CHART_WIDTH,
  height: REDUCED_CHART_HEIGHT,
};

export const NET_MITIGATED_DATA_KEYS_MAP = {
  postMitigationOperationalRisk: "Operational Risk",
  postMitigationWellEntryRisk: "Well Entry Risk",
  netMitigatedRisk: "Net Mitigated Risk",
};

export const REFERENCE_LINE_BASE = {
  strokeDasharray: "2 2",
  strokeWidth: 3,
};

export const PAGE_SIZE = 5;

export const RISK_ASSET_FILTERS_NO_RESULTS_MESSAGE =
  "No assets found with selected filters. Please adjust your filters and try again.";
